var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var itemPathSeparatorChar = '\\';
var maxItemIdLength = 100;
/**
 * Makes an ItemWithPath from an Item by making a shallow clone and adding the parent path.
 */
export var shallowCloneItemWithPath = function (parentPath, item) {
    return __assign(__assign({}, item), { parentPath: parentPath });
};
/**
 * Turns an ItemPath into a string value that can be used as a key (or for logging)
 */
export var makeItemPathKey = function (path) {
    if (Array.isArray(path)) {
        if (path.length === 5) {
            return "" + path[0] + itemPathSeparatorChar + path[1] + itemPathSeparatorChar + path[2] + itemPathSeparatorChar + path[3] + itemPathSeparatorChar + path[4];
        }
        if (path.length === 4) {
            return "" + path[0] + itemPathSeparatorChar + path[1] + itemPathSeparatorChar + path[2] + itemPathSeparatorChar + path[3];
        }
        if (path.length === 3) {
            return "" + path[0] + itemPathSeparatorChar + path[1] + itemPathSeparatorChar + path[2];
        }
        if (path.length === 2) {
            return "" + path[0] + itemPathSeparatorChar + path[1];
        }
        if (path.length === 1) {
            return path[0];
        }
        return path.join(itemPathSeparatorChar);
    }
    return '(malformed path)';
};
/**
 * Reconstitutes an ItemPath from a string key previously created by makeItemPathKey
 */
export var splitItemPathKey = function (pathKey) {
    return pathKey.split(itemPathSeparatorChar);
};
/**
 * Ensures that the given item ID meets our length/charset criteria (in particular
 * to ensure it is round-trippable through makeItemPathKey/splitItemPathKey)
 */
export var isValidItemId = function (itemId) {
    return itemId
        && itemId.length > 0 && itemId.length < maxItemIdLength
        && itemId.indexOf(itemPathSeparatorChar) < 0;
};
/**
 * Returns the provided value if finite; otherwise, returns the default value.
 * @param value The preferred value, if finite.
 * @param defaultValue The failsafe value.
 */
export var getSafeNumber = function (value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    return Number.isFinite(value)
        ? value
        : defaultValue;
};
/**
 * Checks whether item path A is an ancestor (or equal to) item path B
 */
export var isAncestorOrEqualTo = function (a, b) {
    if (a.length > b.length) {
        return false;
    }
    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
};
//# sourceMappingURL=utils.js.map